import { Link } from "react-router-dom";
import { serviceOffers } from "@/lib/service-offers";

const extras = [
    {
        href: "/services/sales",
        title: "Sales Management",
        body: "Manage the pipeline you have, rebuild the process, or put AI on the sales floor.",
        bullets: ["Pipeline management", "Process rebuild", "AI on the floor"],
    },
];

export default function ServicesPage() {
    return (
        <main data-testid="services-page" className="bg-white text-[#0a0a0b]">
            <section className="bg-lavender px-5 pb-12 pt-36 sm:pb-16 sm:pt-44">
                <div className="mx-auto max-w-5xl">
                    <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight sm:text-5xl">
                        Everything we build, in one place
                    </h1>
                    <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-[#5b5b66] sm:text-lg">
                        AI-powered websites and business automation for Canadian businesses — fixed-fee packages,
                        founder-led, with full handover and no lock-in. A first working version in 2–6 weeks; full
                        production in 6–12 weeks.
                    </p>
                    <Link to="/pricing" className="mt-6 inline-flex rounded-full bg-[var(--brand)] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(43,80,255,0.28)]">
                        See package pricing
                    </Link>
                </div>
            </section>

            <section className="px-5 py-16">
                <div className="mx-auto grid max-w-5xl gap-4 md:grid-cols-2">
                    {serviceOffers.map((offer) => (
                        <article key={offer.slug} className="flex flex-col rounded-3xl bg-[#f6f7fb] p-6 ring-1 ring-black/5">
                            <h2 className="font-display text-2xl font-extrabold">{offer.menu}</h2>
                            <p className="mt-2 text-sm leading-relaxed text-[#5b5b66]">{offer.card}</p>
                            <ul className="mt-4 space-y-1 text-sm text-[#3a3a44]">
                                {offer.bullets.map((bullet) => (
                                    <li key={bullet}>• {bullet}</li>
                                ))}
                            </ul>
                            <Link to={`/services/${offer.slug}`} className="mt-5 text-sm font-semibold text-[var(--brand)]">
                                Learn more →
                            </Link>
                        </article>
                    ))}
                    {extras.map((offer) => (
                        <article key={offer.href} className="flex flex-col rounded-3xl bg-[#f6f7fb] p-6 ring-1 ring-black/5">
                            <h2 className="font-display text-2xl font-extrabold">{offer.title}</h2>
                            <p className="mt-2 text-sm leading-relaxed text-[#5b5b66]">{offer.body}</p>
                            <ul className="mt-4 space-y-1 text-sm text-[#3a3a44]">
                                {offer.bullets.map((bullet) => (
                                    <li key={bullet}>• {bullet}</li>
                                ))}
                            </ul>
                            <Link to={offer.href} className="mt-5 text-sm font-semibold text-[var(--brand)]">
                                Learn more →
                            </Link>
                        </article>
                    ))}
                </div>
            </section>

            <section className="px-5 pb-20">
                <div className="mx-auto max-w-5xl rounded-3xl bg-[#0a0a0b] p-6 text-white sm:p-8">
                    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-white/60">Transparent pricing</p>
                    <h2 className="mt-2 font-display text-3xl font-extrabold">$1,997 – $12,000+</h2>
                    <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/70">
                        No hidden fees. All-inclusive packages. A fixed price before the build starts. The audit is free
                        if you are not sure which service fits.
                    </p>
                    <div className="mt-6 flex flex-wrap gap-3">
                        <Link to="/pricing" className="inline-flex rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[#0a0a0b]">See pricing</Link>
                        <Link to="/services/ai-audit" className="inline-flex rounded-full bg-white/10 px-5 py-2.5 text-sm font-semibold text-white ring-1 ring-white/20">Get started</Link>
                    </div>
                </div>
            </section>
        </main>
    );
}
